export * from '@primeuix/themes/material/menubar';
export { default } from '@primeuix/themes/material/menubar';
